export interface DemoVideo {
  id: string;
  title: string;
  description: string;
  videoUrl: string;
  thumbnailUrl?: string;
  duration: string;
  category: 'getting-started' | 'features' | 'tips';
  isFeatured: boolean;
}

export const DEMO_VIDEOS: DemoVideo[] = [
  {
    id: 'intro',
    title: 'Introduction to VoiceThera',
    description: 'Learn what VoiceThera is and how AI-powered personalized wellness sessions can transform your meditation practice.',
    videoUrl: '/videos/intro-video.mp4',
    duration: '5:30',
    category: 'getting-started',
    isFeatured: true,
  },
  {
    id: 'demo',
    title: 'Creating Your First Session',
    description: 'A step-by-step walkthrough of creating your first personalized meditation session with VoiceThera.',
    videoUrl: '/videos/demo-video.mp4',
    duration: '3:15',
    category: 'getting-started',
    isFeatured: true,
  },
  {
    id: 'gift-feature',
    title: 'How to Use the Gift Feature',
    description: 'Learn how to gift personalized meditation sessions to friends and loved ones using VoiceThera.',
    videoUrl: '/videos/gift-feature-demo.mp4',
    duration: '7:12',
    category: 'features',
    isFeatured: false,
  },
];

export const VIDEO_CATEGORIES = [
  { id: 'all', label: 'All Videos' },
  { id: 'getting-started', label: 'Getting Started' },
  { id: 'features', label: 'Features' },
  { id: 'tips', label: 'Tips & Tricks' },
] as const;
